/** Operational Systems known to the system. */
export enum OperationalSystem {
  Windows = 'Windows',
  MacOS = 'MacOS',
  Linux = 'Linux',
  Android = 'Android',
  iOS = 'iOS',
  Unknown = 'Desconhecido',
}

/** Device Types known to the system. */
export enum DeviceType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  Unknown = 'Desconhecido',
}

export const isBrowser = (): boolean => typeof window !== 'undefined'

export const getWindow = (): Window | null => {
  if (!isBrowser()) return null
  return window
}

export const getDocument = (): Document | null => {
  if (!isBrowser()) return null
  return document
}

/**
 * Infers the Client's Operational System from the `userAgent` string, if available.
 * @param userAgent the `userAgent` string.
 * @returns {OperationalSystem} the inferred operational system.
 */
export const getOperationalSystem = (userAgent?: string): OperationalSystem => {
  if (!userAgent) return OperationalSystem.Unknown

  if (/Windows/i.test(userAgent)) return OperationalSystem.Windows
  if (/Mac OS X/i.test(userAgent)) return OperationalSystem.MacOS
  if (/Linux/i.test(userAgent)) return OperationalSystem.Linux
  if (/Android/i.test(userAgent)) return OperationalSystem.Android
  if (/iPhone|iPad|iPod/i.test(userAgent)) return OperationalSystem.iOS

  return OperationalSystem.Unknown
}

/**
 * Infers the Client's Device Type from the `userAgent` string, if available.
 * @param userAgent the `userAgent` string.
 * @returns {DeviceType} the inferred device type.
 */
export const getDeviceType = (userAgent?: string): DeviceType => {
  if (!userAgent) return DeviceType.Unknown

  if (/Mobi/i.test(userAgent)) return DeviceType.Mobile
  if (/Tablet|iPad/i.test(userAgent)) return DeviceType.Tablet

  return DeviceType.Desktop
}
